import { Helpers } from '../../helpers';
import { ISaltWaterDisposalWellStatus } from '../../interfaces/isalt-water-disposal-well-status';
import { SaltWaterDisposalWell } from '../salt-water-disposal-well';

export class SaltWaterDisposalWellStatusBase {
  SaltWaterDisposalWellStatusId: number;
  Description: string;
  SortOrder: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  SaltWaterDisposalWells_SaltWaterDisposalWellStatus?: Array<SaltWaterDisposalWell> | null;

  constructor(item?: ISaltWaterDisposalWellStatus) {
    if (item) {

      this.SaltWaterDisposalWellStatusId = item.SaltWaterDisposalWellStatusId;
      this.Description = item.Description;
      this.SortOrder = item.SortOrder;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.SaltWaterDisposalWells_SaltWaterDisposalWellStatus = Helpers.createClassArray(SaltWaterDisposalWell, item.SaltWaterDisposalWells_SaltWaterDisposalWellStatus);
    }
  }
}